import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import * as _ from 'lodash';
import {DealerProfile} from '../../../Models/DealerProfile';

@Component({
  selector: 'app-dealer-profile-overview',
  templateUrl: './dealer-profile-overview.component.html',
  styleUrls: ['./dealer-profile-overview.component.scss']
})
export class DealerProfileOverviewComponent implements OnInit {

  public grid: Grid;
  public profileId;
  public profileName;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    private translateService: TranslateService,
    private broadcastService: BroadcastService,
    private dealerProfileService: DealerProfileService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.dealer_profile.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.dealer_profile.collections',
          prop: 'collections',
          type: TextColumn.type,
          sortable: false,
          translate: true,
          width: 400,
          valueFormatter: row => {
            const collections = [];
            row.forEach(collection => {
              collections.push(collection.name);
            });
            return _.union(collections).join(', ');
          }
        },
        <NumberColumn>{
          name: 'global.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.dealerProfileService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getProfiles');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/dealer-profile/' + row.id),
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.profileId = row.id;
                this.profileName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => {
                if (row.name !== DealerProfile.DEFAULT_ALL && row.name !== DealerProfile.DEFAULT_NONE) {
                  return row;
                }
              },

              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.dealerProfileService,
      rememberURL: this.router.url,
      method: 'getProfiles',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
    };

  }

  public deleteProfile() {
    this.dealerProfileService.deleteProfile(this.profileId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getProfiles');
    });
  }

}
